<template>
    <div>
        <template v-if="myLeaves !== null">
            <div class="clearfix">
                <div class="page-top mb-1 mb-3 align-center clearfix">
                    <h1 class="float-left"> My Leaves </h1>
                </div>
                <div class="row normal-ib-space mb-3 emp-leaves-progress" v-if="myLeaveQuota && myLeaveQuota.length > 0">
                    <div class="col-md-3" v-for="mlq in myLeaveQuota" :key="mlq.id">
                        <div class="graph-holder">
                            <div :id="'leaves'+mlq.id" style="height:150px;"></div>
                           
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="leave-action">
                            <h2 class="mb-3">Leave Actions</h2>
                            <router-link to="/applyLeave" class="btn btn-primary active"> Apply for Leave </router-link>
                        </div>
                    </div>
                </div>
                <!--<div class="row normal-ib-space mb-3 emp-leaves-progress" v-if="myLeaveQuota.length > 0">
                    <div class="col-md-9">
                        <div class="leave-progress-inner p-4 pl-5 pr-5">
                            <div class="row leave-progress-row align-content-center" >
                                <div class="col-md-4" v-for="mlq in myLeaveQuota" :key="mlq.id">
                                    <div class="progeress-outer clearfix">
                                        <span class="leave-status taken">{{mlq.balance}}</span>
                                        <span class="leave-status total">{{mlq.remaining_leaves}}</span>
                                        <div class="progress " :class="mlq.clas ? 'leave-'+mlq.clas : 'other-leave' ">
                                        <div class="progress-bar" role="progressbar" :style="`width: ${mlq.width}%`" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                        <span class="leave-info leave-type float-left"> {{mlq.title}}</span>
                                        <span class="leave-info leave-percent float-right"> {{parseInt(mlq.width)}}% </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="leave-action">
                            <h2>Leave Actions</h2>
                                <router-link to="/applyLeave" class="btn btn-default"> Apply for Leave </router-link>
                        </div>
                    </div>
                </div>-->

                <div class="page-top mb-1 mb-3 clearfix">
                    <ul class="nav nav-tabs nav-tabs-1 float-left" id="myTab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="approved-tab" data-toggle="tab" href="#approved" role="tab" aria-controls="new" aria-selected="true">Approved ({{approved}})</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="rejected-tab" data-toggle="tab" href="#rejected" role="tab" aria-controls="new" aria-selected="true">Rejected ({{rejected}})</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="pending-tab" data-toggle="tab" href="#pending" role="tab" aria-controls="new" aria-selected="true">Pending ({{pending}})</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="withdrawn-tab" data-toggle="tab" href="#withdrawn" role="tab" aria-controls="paidloan" aria-selected="false">Withdrawn ({{withdrawn}})</a>
                        </li>
                    </ul>
                </div>
                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="approved" role="tabpanel" aria-labelledby="approved-tab">
                        <table id="dt-approved" class="table">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Leave Type</th>
                                    <!-- <th>Line Manager</th> -->
                                    <th>Leave Duration</th>
                                    <th class="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="apl in myLeaves" :key="apl.id" v-if="apl.leave_status == 'APPROVED_HR'">
                                    <td>{{apl.created_at | date_format_day_first}}</td>
                                    <td v-if="apl.partial_leave_duration">{{apl.leave_type}} ( {{apl.partial_leave_duration}} Hours)</td>
                                    <td v-else>{{apl.leave_type}}</td>
                                    <td v-if="apl.leave_start !== apl.leave_end">{{apl.leave_start | date_format_day_first}} - {{apl.leave_end | date_format_day_first}}</td>
                                    <td v-else>{{apl.leave_start | date_format_day_first}}</td>
                                    <!-- <td>{{manager_name(apl)}}</td> -->
                                    <td class="text-center">
                                        <router-link :to="'viewLeaveApplication/'+apl.id" data-toggle="tooltip" data-placement="top" title="View" class="action view text-center">
                                            <i class="fas fa-eye"></i>
                                        </router-link>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="tab-pane fade" id="rejected" role="tabpanel" aria-labelledby="rejected-tab">
                        <table id="dt-rejected" class="table">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Leave Type</th>
                                    <!-- <th>Line Manager</th> -->
                                    <th>Leave Duration</th>
                                    <th class="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="apl in myLeaves" :key="apl.id" v-if="apl.leave_status == 'REJECTED_HR' || apl.leave_status == 'REJECTED_TL'">
                                    <td>{{apl.created_at | date_format_day_first}}</td>
                                    <td v-if="apl.partial_leave_duration">{{apl.leave_type}} ( {{apl.partial_leave_duration}} Hours)</td>
                                    <td v-else>{{apl.leave_type}}</td>
                                    <!-- <td>{{manager_name(apl)}}</td> -->
                                    <td v-if="apl.leave_start !== apl.leave_end">{{apl.leave_start | date_format_day_first}} - {{apl.leave_end | date_format_day_first}}</td>
                                    <td v-else>{{apl.leave_start | date_format_day_first}}</td>
                                    <td class="text-center">
                                        <router-link :to="'viewLeaveApplication/'+apl.id" data-toggle="tooltip" data-placement="top" title="View" class="action view text-center">
                                            <i class="fas fa-eye"></i>
                                        </router-link>
                                        <!-- <a @click="deleteLeave(apl.id, '#dt-rejected')" data-toggle="tooltip" data-placement="top" title="Reject" class="action reject text-center">
                                            <i class="fas fa-times"></i>
                                        </a> -->
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="tab-pane fade" id="pending" role="tabpanel" aria-labelledby="pending-tab">
                        <table id="dt-pending" class="table">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Leave Type</th>
                                    <th>Leave Duration</th>
                                    <th class="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="apl in myLeaves" :key="apl.id" v-if="apl.leave_status == 'PENDING' || apl.leave_status == 'APPROVED_TL'">
                                    <td>{{apl.created_at | date_format_day_first}}</td>
                                    <td v-if="apl.partial_leave_duration">{{apl.leave_type}} ( {{apl.partial_leave_duration}} Hours)</td>
                                    <td v-else>{{apl.leave_type}}</td>
                                    <td v-if="apl.leave_start !== apl.leave_end">{{apl.leave_start | date_format_day_first}} - {{apl.leave_end | date_format_day_first}}</td>
                                    <td v-else>{{apl.leave_start | date_format_day_first}}</td>
                                    <td class="text-center">
                                        <router-link :to="'viewLeaveApplication/'+apl.id" data-toggle="tooltip" data-placement="top" title="View" class="action view text-center">
                                            <i class="fas fa-eye"></i>
                                        </router-link>
                                        <a @click="deleteLeave(apl.id, '#dt-pending')" data-toggle="tooltip" data-placement="top" title="withdrawn" class="action reject text-center">
                                            <i class="fas fa-times"></i>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="tab-pane fade" id="withdrawn" role="tabpanel" aria-labelledby="withdrawn-tab">
                        <table id="dt-withdrawn" class="table">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Leave Type</th>
                                    <!-- <th>Line Manager</th> -->
                                    <th>Leave Duration</th>
                                    <th class="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="apl in myLeaves" :key="apl.id" v-if="apl.leave_status == 'CANCEL'">
                                    <td>{{apl.created_at | date_format_day_first}}</td>
                                    <td v-if="apl.partial_leave_duration">{{apl.leave_type}} ( {{apl.partial_leave_duration}} Hours)</td>
                                    <td v-else>{{apl.leave_type}}</td>
                                    <!-- <td>{{manager_name(apl)}}</td> -->
                                    <td v-if="apl.leave_start !== apl.leave_end">{{apl.leave_start | date_format_day_first}} - {{apl.leave_end | date_format_day_first}}</td>
                                    <td v-else>{{apl.leave_start | date_format_day_first}}</td>
                                    <td class="text-center">
                                        <router-link :to="'viewLeaveApplication/'+apl.id" data-toggle="tooltip" data-placement="top" title="View" class="action view text-center">
                                            <i class="fas fa-eye"></i>
                                        </router-link>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="myLeaves === null">
            <preLoader></preLoader>
        </template>
    </div>
</template>

<script>
var approvedTable = null;
var rejectedTable = null;
var pendingTable = null;
var withdrawnTable = null;

export default {
    data() {
        return {
            myLeaveQuota:null,
            myLeaves:null,
            approved: 0,
            rejected: 0,
            pending: 0,
            withdrawn: 0
        };
    },

    mounted() {
        this.$Progress.start();
        this.getLeavesData();
    },

    created(){

    },
    methods: {

        // manager_name: function(val){
        //     if(val.line_manager == null){
        //         return '------';
        //     }else{
        //         return val.line_manager.name;
        //     }
        // },

        dataTable(){

            approvedTable = $("#dt-approved").DataTable({
                "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r'
            });
            rejectedTable = $("#dt-rejected").DataTable({
                "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r'
            });
            pendingTable = $("#dt-pending").DataTable({
                "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r'
            });
            withdrawnTable = $("#dt-withdrawn").DataTable({
                "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r'
            });
        },

        getLeavesData(){
            let that = this;
            axios.get('/api/leaves')
            .then(res => {
                that.rejected = 0;
                that.pending = 0;
                that.withdrawn = 0;
                that.approved = 0;
                this.myLeaves = [];
                this.myLeaveQuota = [];
                this.myLeaveQuota = res.data.myLeaveQuota;
                this.myLeaves = res.data.myLeaves;
                // loop for calculating count
                _.forEach(this.myLeaves, function(e, i){
                    if(e.leave_status == "REJECTED_HR" || e.leave_status == "REJECTED_TL"){
                        that.rejected++;
                    }else if(e.leave_status == "APPROVED_HR"){
                        that.approved++;
                    }else if(e.leave_status == "PENDING" || e.leave_status == "REJECTED_TL"){
                        that.pending++;
                    }else if(e.leave_status == "CANCEL"){
                        that.withdrawn++;
                    }
                });
                this.$Progress.finish();
            }).then(res => {
                this.dataTable();
                this.leaveChart();
            }).catch(err => {
                console.log(err);
            });
        },

        leaveChart(){
            let data = this.myLeaveQuota;
            _.forEach(data, function(e, i){
                Highcharts.chart('leaves'+e.id, {
                    exporting: {
                        enabled: false
                    },
                    title: {
                        text: ''
                    },
                    plotOptions: {
                        pie: {
                            size:'90px',
                            innerSize: 50,
                            depth: 0,
                            allowPointSelect: true,
                            cursor: 'pointer',
                            dataLabels: {
                                enabled: false
                            }
                        },
                        series: {
                            groupPadding: 0
                        }

                    },
                    credits: false,
                    legend: {
                        align: 'right',
                        verticalAlign: 'middle',
                        layout: 'vertical',
                        itemMarginTop: 5,
                        itemMarginBottom: 5,
                        x: 0,
                        y: 0,
                        labelFormatter: function() {
                            return '<span style="color: '+this.color+'">'+ this.name + '</span>';
                        }
                    },
                    series: [{
                        type: 'pie',
                        dataLabels: {
                            enabled: false
                        },
                        allowPointSelect: true,
                        data: [{
                            name: e.title +' '+e.total,
                            y: parseInt(e.total),
                            color: '#211f20'
                        }, {
                            name: 'Remaining '+e.balance,
                            y: parseInt(e.balance),
                            color: e.clas
                        }],
                        showInLegend: true
                    }]
                });
            });

        },

        deleteLeave(id, html_id){
            this.$Progress.start();
            let that = this;
            swal.fire({
                title: 'Are you sure?',
                text: "",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    axios.get('/api/removeLeave/'+id)
                    .then(res => {
                        if(res.status == 200){
                            that.pending = that.pending - 1;
                            toast.fire({type: 'success', title: 'Your leave has been deleted' });
                            this.$Progress.finish();
                            this.getLeavesData();
                        }else{
                            swal.fire({type: 'error', title: 'Error to delete leave' });
                            this.$Progress.fail();
                        }
                    }).then(res =>{
                    
                    })
                    .catch(err => {
                        swal.fire({type: 'error', title: 'Error to delete leave' });
                        this.$Progress.finish();
                    });
                } else if (result.dismiss === Swal.DismissReason.cancel){
                    swal.fire('Cancelled', 'Your decision has been cancelled', 'error');
                    this.$Progress.finish();
                }
            })
        }
    },
}
</script>
